(() => {
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
      this.controls = this.querySelectorAll('[data-control]');

      this.viewportWidth = window.innerWidth;
      [
        'shopify:section:load',
        'load',
        'resize'
      ].forEach((event) => {
        window.addEventListener(event, () => {
          if (event == 'resize' && window.innerWidth == this.viewportWidth) return;
          this.viewportWidth = window.innerWidth;
          this.calcHeight();
        });
      });
    }

    connectedCallback() {

      const autoplayEnabled = this.dataset.autoplay === 'true';

      this.slider = new Swiper(this, {
  direction: 'vertical',
  loop: Number(this.dataset.slidesCount) > 1,
  effect: Number(this.dataset.slidesCount) > 1 ? 'slide' : 'fade',
        preventClicks: false,
        autoplay: autoplayEnabled ? {
          delay: Number(this.dataset.autoplayInterval),
          disableOnInteraction: false,
        } : false,
        navigation: {
          nextEl: '.hero__arrow-next',
          prevEl: '.hero__arrow-prev',
        },
        on: {
          init: () => {
            this.addAnimationHanler();
            this.updateImageClasses();
          },
          slideChange: () => {
            this.addFadeAnimations();
          },
        },
      });
    }

    addAnimationHanler() {
      this.querySelectorAll('[data-fade-in]')?.forEach((element) => {
        element.addEventListener('animationend', () => {
          this.addFadeAnimations();
        })
      })
    }

    updateImageClasses() {
      this.querySelectorAll('.lazyloading')?.forEach(lazyloadImage => {
        lazyloadImage.classList.remove('lazyloading')
        lazyloadImage.classList.add('lazyloaded')
      })
    }

    addFadeAnimations() {
      this.animatedElements = this.querySelectorAll('[data-fade-in]');
      this.animatedElements.forEach((element) => {
        element.classList.add('fade-in');
      })
    }

    calcHeight() {
      const announcementBar = document.querySelector('.section--announcement-bar:not(.section--header + .section--announcement-bar)');
      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

      const headerOffset =
        announcementBarHeight +
        document.querySelector('.section--header').offsetHeight;

      this.querySelectorAll('.hero__block').forEach((element) => {
        const heroHeight = element.dataset.heroHeight;
        element.style.height =
          window.innerWidth > 989
            ? 'auto'
            : `calc(${heroHeight}vmax - ${headerOffset}px)`;
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
